import { RESET_PORTAL_CONTEXT, RESET_NUEVO_TURNO, SET_NUEVO_TURNO } from "../ActionTypes";
import nuevoTurnoInitialState from "../initialStates/nuevoTurnoInitialState";

const nuevoTurno = (state, { payload, type }) => {
  switch (type) {
    case SET_NUEVO_TURNO:
      return {
        ...state,
        nuevoTurno: {
          ...state.nuevoTurno,
          ...payload,
        },
      };
    case RESET_PORTAL_CONTEXT || RESET_NUEVO_TURNO:
      return nuevoTurnoInitialState;
    case RESET_NUEVO_TURNO:
      return nuevoTurnoInitialState;
    default:
      return state;
  }
};

export default nuevoTurno;
